var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    { attrs: { method: "post" }, on: { submit: _vm.checkForm } },
    [
      _c("h2", { staticClass: "h3" }, [
        _vm._v("\n   " + _vm._s(_vm.header) + "\n  "),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Login: "), _c("strong", [_vm._v(_vm._s(_vm.login))])]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-2 input-group icon icon__key" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.password,
              expression: "password",
            },
          ],
          staticClass: "form-control",
          attrs: {
            type: "password",
            placeholder: _vm.haslo,
            "aria-label": _vm.haslo,
            name: "password",
          },
          domProps: { value: _vm.password },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.password = $event.target.value
              },
              _vm.password_check,
            ],
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "p",
          {
            staticClass: "frmValidation",
            class: {
              "frmValidation--passed":
                _vm.password.length > 7 && _vm.password.length <= 32,
            },
          },
          [
            _c("i", {
              staticClass: "frmIcon bi",
              class:
                _vm.password.length > 7 && _vm.password.length <= 32
                  ? "bi-check"
                  : "bi-x",
            }),
            _vm._v(" " + _vm._s(_vm.dlugosc)),
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "frmValidation",
            class: {
              "frmValidation--passed": _vm.has_uppercase || _vm.checkCount(),
            },
          },
          [
            _c("i", {
              staticClass: "frmIcon bi",
              class: _vm.has_uppercase ? "bi-check" : "bi-x",
            }),
            _vm._v(" " + _vm._s(_vm.wielk)),
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "frmValidation",
            class: {
              "frmValidation--passed": _vm.has_lowercase || _vm.checkCount(),
            },
          },
          [
            _c("i", {
              staticClass: "frmIcon bi",
              class: _vm.has_lowercase ? "bi-check" : "bi-x",
            }),
            _vm._v(" " + _vm._s(_vm.mala)),
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "frmValidation",
            class: {
              "frmValidation--passed": _vm.has_number || _vm.checkCount(),
            },
          },
          [
            _c("i", {
              staticClass: "frmIcon bi",
              class: _vm.has_number ? "bi-check" : "bi-x",
            }),
            _vm._v(" " + _vm._s(_vm.cyfra)),
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "frmValidation",
            class: {
              "frmValidation--passed": _vm.has_special || _vm.checkCount(),
            },
          },
          [
            _c("i", {
              staticClass: "frmIcon bi",
              class: _vm.has_special ? "bi-check" : "bi-x",
            }),
            _vm._v(" " + _vm._s(_vm.znak)),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-2 input-group icon icon__key" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.password_repeat,
              expression: "password_repeat",
            },
          ],
          staticClass: "form-control",
          attrs: {
            type: "password",
            placeholder: _vm.powtorz,
            "aria-label": _vm.powtorz,
            name: "password_repeat",
          },
          domProps: { value: _vm.password_repeat },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.password_repeat = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "p",
          {
            staticClass: "frmValidation",
            class: {
              "frmValidation--passed":
                _vm.password.length > 1 && _vm.password == _vm.password_repeat,
            },
          },
          [
            _c("i", {
              staticClass: "frmIcon bi",
              class:
                _vm.password.length > 1 && _vm.password == _vm.password_repeat
                  ? "bi-check"
                  : "bi-x",
            }),
            _vm._v(" " + _vm._s(_vm.zgodnosc)),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-warning w-100 mb-2",
          attrs: { type: "submit", disabled: _vm.isDisabled },
        },
        [_vm._v(_vm._s(_vm.zmien))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }